const ProductListFour = () => {
  return (
    <>
      <div className=" display-max">
        <div className=" d-flex justify-content-start align-items-center gap-2 mt-3">
          <div className=" col-lg-2">
            <div className="card px-2 border-radius-0 shadow-none mb-lg-0">
              <a href="/DetailPage">
                <div className="card-header p-0 position-relative border-radius-00 z-index-2 bg-gray">
                  <div className="d-block blur-shadow-image">
                    <img
                      src="../../assets/img/products/product-7.png"
                      alt="img-blur-shadow"
                      className="img-fluid-max-screens p-3"
                      loading="lazy"
                    />
                  </div>
                </div>
              </a>
              <div className="p-2 text-start lh-0">
                <div className="d-flex justify-content-between align-items-center">
                  <div>
                    <b className="font-weight-bold mt-1 mb-1">
                      <a href="/DetailPage">Dolce & Gabbana</a>
                    </b>
                  </div>
                  <div>
                    <span className="text-black text-xs">
                      <i className="bi bi-star-fill me-1 text-xxs"></i>4.0
                    </span>
                  </div>
                </div>
                <div className=" mt-1">
                  <div className=" lh-1">
                    <b className="mt-2 fw-normal text-xxs text-black">
                      Dolce & Gabbana's 'Greta' tote has been crafted in Italy
                      from hard-wearing red textured-leather.
                    </b>
                  </div>
                </div>
              </div>
              <div className=" d-flex justify-content-between align-items-center mb-2 px-2">
                <div>
                  <b className="font-bold fs-5 text-black my-auto">
                    <sup className=" fw-normal">₹</sup>1,549{" "}
                    <sub>
                      <b className="fw-normal text-black text-xxs">MRP: </b>{" "}
                      <b className="fw-normal text-black text-xxs text-decoration-line-through">
                        2800.00
                      </b>
                    </sub>
                  </b>
                </div>
                <div>
                  <button
                    className=" btn btn-sm btn-yellow"
                    data-bs-toggle="offcanvas"
                    data-bs-target="#offcanvasMiniCart"
                    aria-controls="offcanvasMiniCart"
                  >
                    Add
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className=" col-lg-2">
            <div className="card px-2 border-radius-0 shadow-none mb-lg-0">
              <a href="/DetailPage">
                <div className="card-header p-0 position-relative border-radius-00 z-index-2 bg-gray">
                  <div className="d-block blur-shadow-image">
                    <img
                      src="../../assets/img/products/product-8.png"
                      alt="img-blur-shadow"
                      className="img-fluid-max-screens p-3"
                      loading="lazy"
                    />
                  </div>
                </div>
              </a>
              <div className="p-2 text-start lh-0">
                <div className="d-flex justify-content-between align-items-center">
                  <div>
                    <b className="font-weight-bold mt-1 mb-1">
                      <a href="/DetailPage">Dolce & Gabbana</a>
                    </b>
                  </div>
                  <div>
                    <span className="text-black text-xs">
                      <i className="bi bi-star-fill me-1 text-xxs"></i>4.0
                    </span>
                  </div>
                </div>
                <div className=" mt-1">
                  <div className=" lh-1">
                    <b className="mt-2 fw-normal text-xxs text-black">
                      Dolce & Gabbana's 'Greta' tote has been crafted in Italy
                      from hard-wearing red textured-leather.
                    </b>
                  </div>
                </div>
              </div>
              <div className=" d-flex justify-content-between align-items-center mb-2 px-2">
                <div>
                  <b className="font-bold fs-5 text-black my-auto">
                    <sup className=" fw-normal">₹</sup>1,549{" "}
                    <sub>
                      <b className="fw-normal text-black text-xxs">MRP: </b>{" "}
                      <b className="fw-normal text-black text-xxs text-decoration-line-through">
                        2800.00
                      </b>
                    </sub>
                  </b>
                </div>
                <div>
                  <button
                    className=" btn btn-sm btn-yellow"
                    data-bs-toggle="offcanvas"
                    data-bs-target="#offcanvasMiniCart"
                    aria-controls="offcanvasMiniCart"
                  >
                    Add
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className=" col-lg-2">
            <div className="card px-2 border-radius-0 shadow-none mb-lg-0">
              <a href="/DetailPage">
                <div className="card-header p-0 position-relative border-radius-00 z-index-2 bg-gray">
                  <div className="d-block blur-shadow-image">
                    <img
                      src="../../assets/img/products/product-9.png"
                      alt="img-blur-shadow"
                      className="img-fluid-max-screens p-3"
                      loading="lazy"
                    />
                  </div>
                </div>
              </a>
              <div className="p-2 text-start lh-0">
                <div className="d-flex justify-content-between align-items-center">
                  <div>
                    <b className="font-weight-bold mt-1 mb-1">
                      <a href="/DetailPage">Dolce & Gabbana</a>
                    </b>
                  </div>
                  <div>
                    <span className="text-black text-xs">
                      <i className="bi bi-star-fill me-1 text-xxs"></i>4.0
                    </span>
                  </div>
                </div>
                <div className=" mt-1">
                  <div className=" lh-1">
                    <b className="mt-2 fw-normal text-xxs text-black">
                      Dolce & Gabbana's 'Greta' tote has been crafted in Italy
                      from hard-wearing red textured-leather.
                    </b>
                  </div>
                </div>
              </div>
              <div className=" d-flex justify-content-between align-items-center mb-2 px-2">
                <div>
                  <b className="font-bold fs-5 text-black my-auto">
                    <sup className=" fw-normal">₹</sup>1,549{" "}
                    <sub>
                      <b className="fw-normal text-black text-xxs">MRP: </b>{" "}
                      <b className="fw-normal text-black text-xxs text-decoration-line-through">
                        2800.00
                      </b>
                    </sub>
                  </b>
                </div>
                <div>
                  <button
                    className=" btn btn-sm btn-yellow"
                    data-bs-toggle="offcanvas"
                    data-bs-target="#offcanvasMiniCart"
                    aria-controls="offcanvasMiniCart"
                  >
                    Add
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className=" col-lg-2">
            <div className="card px-2 border-radius-0 shadow-none mb-lg-0">
              <a href="/DetailPage">
                <div className="card-header p-0 position-relative border-radius-00 z-index-2 bg-gray">
                  <div className="d-block blur-shadow-image">
                    <img
                      src="../../assets/img/products/product-10.png"
                      alt="img-blur-shadow"
                      className="img-fluid-max-screens p-3"
                      loading="lazy"
                    />
                  </div>
                </div>
              </a>
              <div className="p-2 text-start lh-0">
                <div className="d-flex justify-content-between align-items-center">
                  <div>
                    <b className="font-weight-bold mt-1 mb-1">
                      <a href="/DetailPage">Dolce & Gabbana</a>
                    </b>
                  </div>
                  <div>
                    <span className="text-black text-xs">
                      <i className="bi bi-star-fill me-1 text-xxs"></i>4.0
                    </span>
                  </div>
                </div>
                <div className=" mt-1">
                  <div className=" lh-1">
                    <b className="mt-2 fw-normal text-xxs text-black">
                      Dolce & Gabbana's 'Greta' tote has been crafted in Italy
                      from hard-wearing red textured-leather.
                    </b>
                  </div>
                </div>
              </div>
              <div className=" d-flex justify-content-between align-items-center mb-2 px-2">
                <div>
                  <b className="font-bold fs-5 text-black my-auto">
                    <sup className=" fw-normal">₹</sup>1,549{" "}
                    <sub>
                      <b className="fw-normal text-black text-xxs">MRP: </b>{" "}
                      <b className="fw-normal text-black text-xxs text-decoration-line-through">
                        2800.00
                      </b>
                    </sub>
                  </b>
                </div>
                <div>
                  <button
                    className=" btn btn-sm btn-yellow"
                    data-bs-toggle="offcanvas"
                    data-bs-target="#offcanvasMiniCart"
                    aria-controls="offcanvasMiniCart"
                  >
                    Add
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className=" col-lg-2">
            <div className="card px-2 border-radius-0 shadow-none mb-lg-0">
              <a href="/DetailPage">
                <div className="card-header p-0 position-relative border-radius-00 z-index-2 bg-gray">
                  <div className="d-block blur-shadow-image">
                    <img
                      src="../../assets/img/products/product-11.png"
                      alt="img-blur-shadow"
                      className="img-fluid-max-screens p-3"
                      loading="lazy"
                    />
                  </div>
                </div>
              </a>
              <div className="p-2 text-start lh-0">
                <div className="d-flex justify-content-between align-items-center">
                  <div>
                    <b className="font-weight-bold mt-1 mb-1">
                      <a href="/DetailPage">Dolce & Gabbana</a>
                    </b>
                  </div>
                  <div>
                    <span className="text-black text-xs">
                      <i className="bi bi-star-fill me-1 text-xxs"></i>4.0
                    </span>
                  </div>
                </div>
                <div className=" mt-1">
                  <div className=" lh-1">
                    <b className="mt-2 fw-normal text-xxs text-black">
                      Dolce & Gabbana's 'Greta' tote has been crafted in Italy
                      from hard-wearing red textured-leather.
                    </b>
                  </div>
                </div>
              </div>
              <div className=" d-flex justify-content-between align-items-center mb-2 px-2">
                <div>
                  <b className="font-bold fs-5 text-black my-auto">
                    <sup className=" fw-normal">₹</sup>1,549{" "}
                    <sub>
                      <b className="fw-normal text-black text-xxs">MRP: </b>{" "}
                      <b className="fw-normal text-black text-xxs text-decoration-line-through">
                        2800.00
                      </b>
                    </sub>
                  </b>
                </div>
                <div>
                  <button
                    className=" btn btn-sm btn-yellow"
                    data-bs-toggle="offcanvas"
                    data-bs-target="#offcanvasMiniCart"
                    aria-controls="offcanvasMiniCart"
                  >
                    Add
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className=" col-lg-2">
            <div className="card px-2 border-radius-0 shadow-none mb-lg-0">
              <a href="/DetailPage">
                <div className="card-header p-0 position-relative border-radius-00 z-index-2 bg-gray">
                  <div className="d-block blur-shadow-image">
                    <img
                      src="../../assets/img/products/product-12.png"
                      alt="img-blur-shadow"
                      className="img-fluid-max-screens p-3"
                      loading="lazy"
                    />
                  </div>
                </div>
              </a>
              <div className="p-2 text-start lh-0">
                <div className="d-flex justify-content-between align-items-center">
                  <div>
                    <b className="font-weight-bold mt-1 mb-1">
                      <a href="/DetailPage">Dolce & Gabbana</a>
                    </b>
                  </div>
                  <div>
                    <span className="text-black text-xs">
                      <i className="bi bi-star-fill me-1 text-xxs"></i>4.0
                    </span>
                  </div>
                </div>
                <div className=" mt-1">
                  <div className=" lh-1">
                    <b className="mt-2 fw-normal text-xxs text-black">
                      Dolce & Gabbana's 'Greta' tote has been crafted in Italy
                      from hard-wearing red textured-leather.
                    </b>
                  </div>
                </div>
              </div>
              <div className=" d-flex justify-content-between align-items-center mb-2 px-2">
                <div>
                  <b className="font-bold fs-5 text-black my-auto">
                    <sup className=" fw-normal">₹</sup>1,549{" "}
                    <sub>
                      <b className="fw-normal text-black text-xxs">MRP: </b>{" "}
                      <b className="fw-normal text-black text-xxs text-decoration-line-through">
                        2800.00
                      </b>
                    </sub>
                  </b>
                </div>
                <div>
                  <button
                    className=" btn btn-sm btn-yellow"
                    data-bs-toggle="offcanvas"
                    data-bs-target="#offcanvasMiniCart"
                    aria-controls="offcanvasMiniCart"
                  >
                    Add
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className=" display-mini display-mob">
        <div className=" d-flex justify-content-start align-items-center px-1 mb-3">
          <div className="w-100">
            <div className="card px-1 border-radius-0 shadow-none mb-lg-0">
              <a href="/DetailPage">
                <div className="card-header p-0 position-relative border-radius-00 z-index-2 bg-gray">
                  <div className="d-block blur-shadow-image">
                    <img
                      src="../../assets/img/products/product-13.png"
                      alt="img-blur-shadow"
                      className="img-fluid-mini-screens p-1"
                      loading="lazy"
                    />
                  </div>
                </div>
              </a>
              <div className="p-2 text-start lh-0">
                <div className="d-flex justify-content-between align-items-center">
                  <div>
                    <b className="font-weight-bold mt-1 mb-1">
                      <a href="/DetailPage">Dolce & Gabbana</a>
                    </b>
                  </div>
                  <div>
                    <span className="text-black text-xs">
                      <i className="bi bi-star-fill me-1 text-xxs"></i>4.0
                    </span>
                  </div>
                </div>
                <div className=" mt-1">
                  <div className=" lh-1">
                    <b className="mt-1 fw-normal text-xxs text-black">
                      Dolce & Gabbana's 'Greta' tote has been crafted in Italy
                      from hard-wearing red textured-leather.
                    </b>
                  </div>
                </div>
              </div>
              <div className=" d-flex justify-content-between align-items-end mb-2 mt-2 px-2">
                <div className=" lh-1">
                  <b className="font-bold fs-5 text-black my-auto">
                    <sup className=" fw-normal">₹</sup>1,549{" "}
                  </b>
                  <div>
                    {" "}
                    <sub>
                      <b className="fw-normal text-black text-xxs">MRP: </b>{" "}
                      <b className="fw-normal text-black text-xxs text-decoration-line-through">
                        2800.00
                      </b>
                    </sub>
                  </div>
                </div>
                <div>
                  <a href="/Cart">
                    <button className=" btn btn-sm btn-yellow">Add</button>
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div className="w-100">
            <div className="card px-1 border-radius-0 shadow-none mb-lg-0">
              <a href="/DetailPage">
                <div className="card-header p-0 position-relative border-radius-00 z-index-2 bg-gray">
                  <div className="d-block blur-shadow-image">
                    <img
                      src="../../assets/img/products/product-14.png"
                      alt="img-blur-shadow"
                      className="img-fluid-mini-screens p-1"
                      loading="lazy"
                    />
                  </div>
                </div>
              </a>
              <div className="p-2 text-start lh-0">
                <div className="d-flex justify-content-between align-items-center">
                  <div>
                    <b className="font-weight-bold mt-1 mb-1">
                      <a href="/DetailPage">Dolce & Gabbana</a>
                    </b>
                  </div>
                  <div>
                    <span className="text-black text-xs">
                      <i className="bi bi-star-fill me-1 text-xxs"></i>4.0
                    </span>
                  </div>
                </div>
                <div className=" mt-1">
                  <div className=" lh-1">
                    <b className="mt-1 fw-normal text-xxs text-black">
                      Dolce & Gabbana's 'Greta' tote has been crafted in Italy
                      from hard-wearing red textured-leather.
                    </b>
                  </div>
                </div>
              </div>
              <div className=" d-flex justify-content-between align-items-end mb-2 mt-2 px-2">
                <div className=" lh-1">
                  <b className="font-bold fs-5 text-black my-auto">
                    <sup className=" fw-normal">₹</sup>1,549{" "}
                  </b>
                  <div>
                    {" "}
                    <sub>
                      <b className="fw-normal text-black text-xxs">MRP: </b>{" "}
                      <b className="fw-normal text-black text-xxs text-decoration-line-through">
                        2800.00
                      </b>
                    </sub>
                  </div>
                </div>
                <div>
                  <a href="/Cart">
                    <button className=" btn btn-sm btn-yellow">Add</button>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className=" d-flex justify-content-start align-items-center px-1 mb-3">
          <div className="w-100">
            <div className="card px-1 border-radius-0 shadow-none mb-lg-0">
              <a href="/DetailPage">
                <div className="card-header p-0 position-relative border-radius-00 z-index-2 bg-gray">
                  <div className="d-block blur-shadow-image">
                    <img
                      src="../../assets/img/products/product-15.png"
                      alt="img-blur-shadow"
                      className="img-fluid-mini-screens p-1"
                      loading="lazy"
                    />
                  </div>
                </div>
              </a>
              <div className="p-2 text-start lh-0">
                <div className="d-flex justify-content-between align-items-center">
                  <div>
                    <b className="font-weight-bold mt-1 mb-1">
                      <a href="/DetailPage">Dolce & Gabbana</a>
                    </b>
                  </div>
                  <div>
                    <span className="text-black text-xs">
                      <i className="bi bi-star-fill me-1 text-xxs"></i>4.0
                    </span>
                  </div>
                </div>
                <div className=" mt-1">
                  <div className=" lh-1">
                    <b className="mt-1 fw-normal text-xxs text-black">
                      Dolce & Gabbana's 'Greta' tote has been crafted in Italy
                      from hard-wearing red textured-leather.
                    </b>
                  </div>
                </div>
              </div>
              <div className=" d-flex justify-content-between align-items-end mb-2 mt-2 px-2">
                <div className=" lh-1">
                  <b className="font-bold fs-5 text-black my-auto">
                    <sup className=" fw-normal">₹</sup>1,549{" "}
                  </b>
                  <div>
                    {" "}
                    <sub>
                      <b className="fw-normal text-black text-xxs">MRP: </b>{" "}
                      <b className="fw-normal text-black text-xxs text-decoration-line-through">
                        2800.00
                      </b>
                    </sub>
                  </div>
                </div>
                <div>
                  <a href="/Cart">
                    <button className=" btn btn-sm btn-yellow">Add</button>
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div className="w-100">
            <div className="card px-1 border-radius-0 shadow-none mb-lg-0">
              <a href="/DetailPage">
                <div className="card-header p-0 position-relative border-radius-00 z-index-2 bg-gray">
                  <div className="d-block blur-shadow-image">
                    <img
                      src="../../assets/img/products/product-16.png"
                      alt="img-blur-shadow"
                      className="img-fluid-mini-screens p-1"
                      loading="lazy"
                    />
                  </div>
                </div>
              </a>
              <div className="p-2 text-start lh-0">
                <div className="d-flex justify-content-between align-items-center">
                  <div>
                    <b className="font-weight-bold mt-1 mb-1">
                      <a href="/DetailPage">Dolce & Gabbana</a>
                    </b>
                  </div>
                  <div>
                    <span className="text-black text-xs">
                      <i className="bi bi-star-fill me-1 text-xxs"></i>4.0
                    </span>
                  </div>
                </div>
                <div className=" mt-1">
                  <div className=" lh-1">
                    <b className="mt-1 fw-normal text-xxs text-black">
                      Dolce & Gabbana's 'Greta' tote has been crafted in Italy
                      from hard-wearing red textured-leather.
                    </b>
                  </div>
                </div>
              </div>
              <div className=" d-flex justify-content-between align-items-end mb-2 mt-2 px-2">
                <div className=" lh-1">
                  <b className="font-bold fs-5 text-black my-auto">
                    <sup className=" fw-normal">₹</sup>1,549{" "}
                  </b>
                  <div>
                    {" "}
                    <sub>
                      <b className="fw-normal text-black text-xxs">MRP: </b>{" "}
                      <b className="fw-normal text-black text-xxs text-decoration-line-through">
                        2800.00
                      </b>
                    </sub>
                  </div>
                </div>
                <div>
                  <a href="/Cart">
                    <button className=" btn btn-sm btn-yellow">Add</button>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ProductListFour;
